import { render } from "./raw-displayer.vue?vue&type=template&id=84f80b60&scoped=true"
import script from "./raw-displayer.vue?vue&type=script&lang=js"
export * from "./raw-displayer.vue?vue&type=script&lang=js"

import "./raw-displayer.vue?vue&type=style&index=0&id=84f80b60&scoped=true&lang=css"

import exportComponent from "/media/dolar/office/office_project/barmm-admin-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84f80b60"]])

export default __exports__